import React from 'react';
import { useIntl } from 'react-intl';

import { cn } from '../../utils/classname';
import IconButton from '../icon-button/icon-button';
import './social-media.scss';

type Props = {
  className?: string;
  intlType?: 'share' | 'share-card' | 'giveaway';
};

export const SocialMedia: React.FC<Props> = ({ className, intlType }) => {
  const intl = useIntl();
  const baseURL = location.origin + location.pathname;
  const classes = cn('bd-social-media', className);

  const facebook = intl.formatMessage({ id: `translate.generic.${intlType}.facebook.personal` }, { url: baseURL });
  const instagram = intl.formatMessage({ id: `translate.generic.${intlType}.instagram.personal` }, { url: baseURL });
  const twitter = intl.formatMessage({ id: `translate.generic.${intlType}.twitter.personal` }, { url: baseURL });
  const tiktok = intl.formatMessage({ id: `translate.generic.${intlType}.tiktok.personal` }, { url: baseURL });

  return (
    <div className={classes} data-component="social-media">
      {Boolean(facebook) && (
        <IconButton href={facebook} name="facebook" height={26} className="bd-social-media__icon-wrapper" />
      )}

      {Boolean(instagram) && (
        <IconButton href={instagram} name="instagram" height={26} className="bd-social-media__icon-wrapper" />
      )}

      {Boolean(twitter) && (
        <IconButton href={twitter} name="twitter" height={26} className="bd-social-media__icon-wrapper" />
      )}

      {Boolean(tiktok) && (
        <IconButton href={tiktok} name="tiktok" height={26} className="bd-social-media__icon-wrapper" />
      )}
    </div>
  );
};

SocialMedia.defaultProps = {
  intlType: 'share'
};
